export enum PublishIconStates {
  Default = 'default',
  Success = 'success',
  Fail = 'fail',
  Retry = 'retry'
}
